export const defaultCarWashVolumes = [20, 50, 100];
export const defaultCarWashPricePerUnit = 1;
